import { useRef, useState, useEffect } from "react";
import { ReactComponent as DrxIcon } from "@/assets/icons/drx-logo-black.svg";
import { ReactComponent as DrxText } from "@/assets/icons/drx-text-black.svg";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/api/axios";
import Input from "@/components/Input";
import InputPass from "@/components/InputPassword";
import Button from "@/components/Button";
import useAuth from "@/hooks/useAuth";
import Cookies from "js-cookie";
import "./style.scss";

const Login = () => {
  const { login } = useAuth();
  const isAuthenticated = !!Cookies.get("access_token");
  const errRef = useRef();
  const location = useLocation();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errMessage, setErrMessage] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setErrMessage("");
  }, [email, password]);

  useEffect(() => {
    if (isAuthenticated) navigate("/dashboard", { replace: true });
  }, [location]);

  const handleLogin = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      login(data?.data);
      setEmail("");
      setPassword("");
      setLoading(false);
    } catch (err: any) {
      console.log("err login >", err.response?.data?.message);
      if (!err?.response) {
        setErrMessage("No Server Response");
      } else if (err.response?.status === 400) {
        setErrMessage("Incorrect Email or Password");
      } else if (err.response?.status === 401) {
        setErrMessage("Unauthorized");
      } else {
        setErrMessage("Login Failed");
      }
      //@ts-ignore
      errRef.current.focus();
      setLoading(false);
    }
  };

  return (
    <div className="login-page-wrapper">
      <form onSubmit={handleLogin}>
        <div className="login-box">
          <DrxIcon className="drx-icon" />
          <DrxText className="drx-text" />
          <div className="divider" />
          <span className="text title">Welcome Back</span>
          <span className="text subtitle">Please enter your details.</span>
          <Input
            style={{ width: "360px" }}
            withIcon={false}
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            required
          />
          <InputPass
            style={{ width: "360px" }}
            withIcon={false}
            value={password}
            placeholder="Password"
            required
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button
            loading={loading}
            style={{ width: "360px" }}
            label="Sign in"
            size="md"
          />
        </div>
      </form>
      <p
        //@ts-ignore
        ref={errRef}
        className={errMessage ? "errmsg" : "offscreen"}
        aria-live="assertive"
      >
        {errMessage}
      </p>
    </div>
  );
};

export default Login;
